import { render, staticRenderFns } from "./issue-detail.vue?vue&type=template&id=d42800b6&scoped=true&"
import script from "./issue-detail.vue?vue&type=script&lang=js&"
export * from "./issue-detail.vue?vue&type=script&lang=js&"
import style0 from "./issue-detail.vue?vue&type=style&index=0&id=d42800b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42800b6",
  null
  
)

export default component.exports